"use client";

import type { Product } from "@/config/products";
import { HeaderSection } from "@/components/shared/header-section";
import MaxWidthWrapper from "@/components/shared/max-width-wrapper";
import { cn } from "@/lib/utils";
import { ProductCard } from "./product-card";

interface ProductsGridProps {
  products?: Product[];
}

export function ProductsGrid({ products: propProducts }: ProductsGridProps) {
  const products = propProducts ?? [];

  return (
    <MaxWidthWrapper className="flex w-full flex-col gap-8 py-4 md:py-8">
      <section className="flex flex-col items-center text-center">
        <HeaderSection
          label="Products"
          title="Available products"
          subtitle="Choose from our selection of premium software solutions."
        />
      </section>

      {/* Products grid */}
      <section className="flex flex-col gap-6">
        <div
          className={cn(
            "mx-auto grid w-full max-w-7xl grid-cols-1 justify-items-center gap-6 sm:grid-cols-2 lg:gap-8",
            products.length >= 4
              ? "lg:grid-cols-3 2xl:grid-cols-4"
              : "lg:grid-cols-3",
          )}
        >
          {products.map((product) => (
            <div key={product.id} className="flex w-full max-w-[420px] justify-center">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
        {products.length === 0 && (
          <p className="py-12 text-center text-muted-foreground">
            No products available.
          </p>
        )}
      </section>
    </MaxWidthWrapper>
  );
}
